import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
    namespaced: true,
    state: {
        sessionOrder: null,
        editingOrderItemId: null,
    },
    getters,
    actions,
    mutations
}